// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const okidogi: PokeData = {
  "id": 1014,
  "name": "okidogi",
  "height": 18,
  "weight": 922,
  "base_experience": 278,
  "types": [
    PokeType.POISON,
    PokeType.FIGHTING
  ],
  "api_moves": [
    "bite",
    "low-kick",
    "counter",
    "crunch",
    "superpower",
    "poison-fang",
    "howl",
    "bulk-up",
    "force-palm",
    "poison-jab",
    "giga-impact",
    "brutal-swing"
  ],
  "moves": [
    "bite",
    "crunch",
    "superpower",
    "poison-fang",
    "bulk-up",
    "poison-jab",
    "venom-drench",
    "rolling-kick",
    "stun-spore",
    "toxic-overload",
    "acid",
    "mortal-gas",
    "close-combat"
  ],
  "evolution_chain": {
    "id": 540,
    "item": null,
    "species": [
      {
        "name": "okidogi",
        "order": 1016,
        "types": [
          PokeType.POISON,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 125,
    "speed": 106,
    "ability_power": 169
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
